/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WorkflowsRouteImport } from './routes/workflows'
import { Route as TeamcenterRouteImport } from './routes/teamcenter'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SavedWorkflowsRouteImport } from './routes/saved-workflows'
import { Route as RunsRouteImport } from './routes/runs'
import { Route as MyMacrosRouteImport } from './routes/my-macros'
import { Route as KnowledgeRouteImport } from './routes/knowledge'
import { Route as IntegrationsRouteImport } from './routes/integrations'
import { Route as HostsRouteImport } from './routes/hosts'
import { Route as CopilotRouteImport } from './routes/copilot'
import { Route as CatalogRouteImport } from './routes/catalog'
import { Route as BuilderRouteImport } from './routes/builder'
import { Route as AuditRouteImport } from './routes/audit'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WorkflowsIndexRouteImport } from './routes/workflows.index'
import { Route as RunsIndexRouteImport } from './routes/runs.index'
import { Route as KnowledgeIndexRouteImport } from './routes/knowledge.index'
import { Route as IntegrationsIndexRouteImport } from './routes/integrations.index'
import { Route as CatalogIndexRouteImport } from './routes/catalog.index'
import { Route as WorkflowsComposeRouteImport } from './routes/workflows.compose'
import { Route as WorkflowsWorkflowIdRouteImport } from './routes/workflows.$workflowId'
import { Route as RunsRunIdRouteImport } from './routes/runs.$runId'
import { Route as KnowledgeItemIdRouteImport } from './routes/knowledge.$itemId'
import { Route as IntegrationsCadEnvRouteImport } from './routes/integrations.$cadEnv'
import { Route as CatalogMacroIdRouteImport } from './routes/catalog.$macroId'
import { Route as WorkflowsComposeWorkflowIdRouteImport } from './routes/workflows.compose.$workflowId'

const WorkflowsRoute = WorkflowsRouteImport.update({
  id: '/workflows',
  path: '/workflows',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamcenterRoute = TeamcenterRouteImport.update({
  id: '/teamcenter',
  path: '/teamcenter',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SavedWorkflowsRoute = SavedWorkflowsRouteImport.update({
  id: '/saved-workflows',
  path: '/saved-workflows',
  getParentRoute: () => rootRouteImport,
} as any)
const RunsRoute = RunsRouteImport.update({
  id: '/runs',
  path: '/runs',
  getParentRoute: () => rootRouteImport,
} as any)
const MyMacrosRoute = MyMacrosRouteImport.update({
  id: '/my-macros',
  path: '/my-macros',
  getParentRoute: () => rootRouteImport,
} as any)
const KnowledgeRoute = KnowledgeRouteImport.update({
  id: '/knowledge',
  path: '/knowledge',
  getParentRoute: () => rootRouteImport,
} as any)
const IntegrationsRoute = IntegrationsRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => rootRouteImport,
} as any)
const HostsRoute = HostsRouteImport.update({
  id: '/hosts',
  path: '/hosts',
  getParentRoute: () => rootRouteImport,
} as any)
const CopilotRoute = CopilotRouteImport.update({
  id: '/copilot',
  path: '/copilot',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogRoute = CatalogRouteImport.update({
  id: '/catalog',
  path: '/catalog',
  getParentRoute: () => rootRouteImport,
} as any)
const BuilderRoute = BuilderRouteImport.update({
  id: '/builder',
  path: '/builder',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditRoute = AuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkflowsIndexRoute = WorkflowsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => WorkflowsRoute,
} as any)
const RunsIndexRoute = RunsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RunsRoute,
} as any)
const KnowledgeIndexRoute = KnowledgeIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => KnowledgeRoute,
} as any)
const IntegrationsIndexRoute = IntegrationsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => IntegrationsRoute,
} as any)
const CatalogIndexRoute = CatalogIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CatalogRoute,
} as any)
const WorkflowsComposeRoute = WorkflowsComposeRouteImport.update({
  id: '/compose',
  path: '/compose',
  getParentRoute: () => WorkflowsRoute,
} as any)
const WorkflowsWorkflowIdRoute = WorkflowsWorkflowIdRouteImport.update({
  id: '/$workflowId',
  path: '/$workflowId',
  getParentRoute: () => WorkflowsRoute,
} as any)
const RunsRunIdRoute = RunsRunIdRouteImport.update({
  id: '/$runId',
  path: '/$runId',
  getParentRoute: () => RunsRoute,
} as any)
const KnowledgeItemIdRoute = KnowledgeItemIdRouteImport.update({
  id: '/$itemId',
  path: '/$itemId',
  getParentRoute: () => KnowledgeRoute,
} as any)
const IntegrationsCadEnvRoute = IntegrationsCadEnvRouteImport.update({
  id: '/$cadEnv',
  path: '/$cadEnv',
  getParentRoute: () => IntegrationsRoute,
} as any)
const CatalogMacroIdRoute = CatalogMacroIdRouteImport.update({
  id: '/$macroId',
  path: '/$macroId',
  getParentRoute: () => CatalogRoute,
} as any)
const WorkflowsComposeWorkflowIdRoute =
  WorkflowsComposeWorkflowIdRouteImport.update({
    id: '/$workflowId',
    path: '/$workflowId',
    getParentRoute: () => WorkflowsComposeRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/audit': typeof AuditRoute
  '/builder': typeof BuilderRoute
  '/catalog': typeof CatalogRouteWithChildren
  '/copilot': typeof CopilotRoute
  '/hosts': typeof HostsRoute
  '/integrations': typeof IntegrationsRouteWithChildren
  '/knowledge': typeof KnowledgeRouteWithChildren
  '/my-macros': typeof MyMacrosRoute
  '/runs': typeof RunsRouteWithChildren
  '/saved-workflows': typeof SavedWorkflowsRoute
  '/settings': typeof SettingsRoute
  '/teamcenter': typeof TeamcenterRoute
  '/workflows': typeof WorkflowsRouteWithChildren
  '/catalog/$macroId': typeof CatalogMacroIdRoute
  '/integrations/$cadEnv': typeof IntegrationsCadEnvRoute
  '/knowledge/$itemId': typeof KnowledgeItemIdRoute
  '/runs/$runId': typeof RunsRunIdRoute
  '/workflows/$workflowId': typeof WorkflowsWorkflowIdRoute
  '/workflows/compose': typeof WorkflowsComposeRouteWithChildren
  '/catalog/': typeof CatalogIndexRoute
  '/integrations/': typeof IntegrationsIndexRoute
  '/knowledge/': typeof KnowledgeIndexRoute
  '/runs/': typeof RunsIndexRoute
  '/workflows/': typeof WorkflowsIndexRoute
  '/workflows/compose/$workflowId': typeof WorkflowsComposeWorkflowIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/audit': typeof AuditRoute
  '/builder': typeof BuilderRoute
  '/copilot': typeof CopilotRoute
  '/hosts': typeof HostsRoute
  '/my-macros': typeof MyMacrosRoute
  '/saved-workflows': typeof SavedWorkflowsRoute
  '/settings': typeof SettingsRoute
  '/teamcenter': typeof TeamcenterRoute
  '/catalog/$macroId': typeof CatalogMacroIdRoute
  '/integrations/$cadEnv': typeof IntegrationsCadEnvRoute
  '/knowledge/$itemId': typeof KnowledgeItemIdRoute
  '/runs/$runId': typeof RunsRunIdRoute
  '/workflows/$workflowId': typeof WorkflowsWorkflowIdRoute
  '/workflows/compose': typeof WorkflowsComposeRouteWithChildren
  '/catalog': typeof CatalogIndexRoute
  '/integrations': typeof IntegrationsIndexRoute
  '/knowledge': typeof KnowledgeIndexRoute
  '/runs': typeof RunsIndexRoute
  '/workflows': typeof WorkflowsIndexRoute
  '/workflows/compose/$workflowId': typeof WorkflowsComposeWorkflowIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/audit': typeof AuditRoute
  '/builder': typeof BuilderRoute
  '/catalog': typeof CatalogRouteWithChildren
  '/copilot': typeof CopilotRoute
  '/hosts': typeof HostsRoute
  '/integrations': typeof IntegrationsRouteWithChildren
  '/knowledge': typeof KnowledgeRouteWithChildren
  '/my-macros': typeof MyMacrosRoute
  '/runs': typeof RunsRouteWithChildren
  '/saved-workflows': typeof SavedWorkflowsRoute
  '/settings': typeof SettingsRoute
  '/teamcenter': typeof TeamcenterRoute
  '/workflows': typeof WorkflowsRouteWithChildren
  '/catalog/$macroId': typeof CatalogMacroIdRoute
  '/integrations/$cadEnv': typeof IntegrationsCadEnvRoute
  '/knowledge/$itemId': typeof KnowledgeItemIdRoute
  '/runs/$runId': typeof RunsRunIdRoute
  '/workflows/$workflowId': typeof WorkflowsWorkflowIdRoute
  '/workflows/compose': typeof WorkflowsComposeRouteWithChildren
  '/catalog/': typeof CatalogIndexRoute
  '/integrations/': typeof IntegrationsIndexRoute
  '/knowledge/': typeof KnowledgeIndexRoute
  '/runs/': typeof RunsIndexRoute
  '/workflows/': typeof WorkflowsIndexRoute
  '/workflows/compose/$workflowId': typeof WorkflowsComposeWorkflowIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/audit'
    | '/builder'
    | '/catalog'
    | '/copilot'
    | '/hosts'
    | '/integrations'
    | '/knowledge'
    | '/my-macros'
    | '/runs'
    | '/saved-workflows'
    | '/settings'
    | '/teamcenter'
    | '/workflows'
    | '/catalog/$macroId'
    | '/integrations/$cadEnv'
    | '/knowledge/$itemId'
    | '/runs/$runId'
    | '/workflows/$workflowId'
    | '/workflows/compose'
    | '/catalog/'
    | '/integrations/'
    | '/knowledge/'
    | '/runs/'
    | '/workflows/'
    | '/workflows/compose/$workflowId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/audit'
    | '/builder'
    | '/copilot'
    | '/hosts'
    | '/my-macros'
    | '/saved-workflows'
    | '/settings'
    | '/teamcenter'
    | '/catalog/$macroId'
    | '/integrations/$cadEnv'
    | '/knowledge/$itemId'
    | '/runs/$runId'
    | '/workflows/$workflowId'
    | '/workflows/compose'
    | '/catalog'
    | '/integrations'
    | '/knowledge'
    | '/runs'
    | '/workflows'
    | '/workflows/compose/$workflowId'
  id:
    | '__root__'
    | '/'
    | '/audit'
    | '/builder'
    | '/catalog'
    | '/copilot'
    | '/hosts'
    | '/integrations'
    | '/knowledge'
    | '/my-macros'
    | '/runs'
    | '/saved-workflows'
    | '/settings'
    | '/teamcenter'
    | '/workflows'
    | '/catalog/$macroId'
    | '/integrations/$cadEnv'
    | '/knowledge/$itemId'
    | '/runs/$runId'
    | '/workflows/$workflowId'
    | '/workflows/compose'
    | '/catalog/'
    | '/integrations/'
    | '/knowledge/'
    | '/runs/'
    | '/workflows/'
    | '/workflows/compose/$workflowId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuditRoute: typeof AuditRoute
  BuilderRoute: typeof BuilderRoute
  CatalogRoute: typeof CatalogRouteWithChildren
  CopilotRoute: typeof CopilotRoute
  HostsRoute: typeof HostsRoute
  IntegrationsRoute: typeof IntegrationsRouteWithChildren
  KnowledgeRoute: typeof KnowledgeRouteWithChildren
  MyMacrosRoute: typeof MyMacrosRoute
  RunsRoute: typeof RunsRouteWithChildren
  SavedWorkflowsRoute: typeof SavedWorkflowsRoute
  SettingsRoute: typeof SettingsRoute
  TeamcenterRoute: typeof TeamcenterRoute
  WorkflowsRoute: typeof WorkflowsRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/workflows': {
      id: '/workflows'
      path: '/workflows'
      fullPath: '/workflows'
      preLoaderRoute: typeof WorkflowsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/teamcenter': {
      id: '/teamcenter'
      path: '/teamcenter'
      fullPath: '/teamcenter'
      preLoaderRoute: typeof TeamcenterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/saved-workflows': {
      id: '/saved-workflows'
      path: '/saved-workflows'
      fullPath: '/saved-workflows'
      preLoaderRoute: typeof SavedWorkflowsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/runs': {
      id: '/runs'
      path: '/runs'
      fullPath: '/runs'
      preLoaderRoute: typeof RunsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/my-macros': {
      id: '/my-macros'
      path: '/my-macros'
      fullPath: '/my-macros'
      preLoaderRoute: typeof MyMacrosRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/knowledge': {
      id: '/knowledge'
      path: '/knowledge'
      fullPath: '/knowledge'
      preLoaderRoute: typeof KnowledgeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/integrations': {
      id: '/integrations'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof IntegrationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/hosts': {
      id: '/hosts'
      path: '/hosts'
      fullPath: '/hosts'
      preLoaderRoute: typeof HostsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/copilot': {
      id: '/copilot'
      path: '/copilot'
      fullPath: '/copilot'
      preLoaderRoute: typeof CopilotRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog': {
      id: '/catalog'
      path: '/catalog'
      fullPath: '/catalog'
      preLoaderRoute: typeof CatalogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/builder': {
      id: '/builder'
      path: '/builder'
      fullPath: '/builder'
      preLoaderRoute: typeof BuilderRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit': {
      id: '/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/workflows/': {
      id: '/workflows/'
      path: '/'
      fullPath: '/workflows/'
      preLoaderRoute: typeof WorkflowsIndexRouteImport
      parentRoute: typeof WorkflowsRoute
    }
    '/runs/': {
      id: '/runs/'
      path: '/'
      fullPath: '/runs/'
      preLoaderRoute: typeof RunsIndexRouteImport
      parentRoute: typeof RunsRoute
    }
    '/knowledge/': {
      id: '/knowledge/'
      path: '/'
      fullPath: '/knowledge/'
      preLoaderRoute: typeof KnowledgeIndexRouteImport
      parentRoute: typeof KnowledgeRoute
    }
    '/integrations/': {
      id: '/integrations/'
      path: '/'
      fullPath: '/integrations/'
      preLoaderRoute: typeof IntegrationsIndexRouteImport
      parentRoute: typeof IntegrationsRoute
    }
    '/catalog/': {
      id: '/catalog/'
      path: '/'
      fullPath: '/catalog/'
      preLoaderRoute: typeof CatalogIndexRouteImport
      parentRoute: typeof CatalogRoute
    }
    '/workflows/compose': {
      id: '/workflows/compose'
      path: '/compose'
      fullPath: '/workflows/compose'
      preLoaderRoute: typeof WorkflowsComposeRouteImport
      parentRoute: typeof WorkflowsRoute
    }
    '/workflows/$workflowId': {
      id: '/workflows/$workflowId'
      path: '/$workflowId'
      fullPath: '/workflows/$workflowId'
      preLoaderRoute: typeof WorkflowsWorkflowIdRouteImport
      parentRoute: typeof WorkflowsRoute
    }
    '/runs/$runId': {
      id: '/runs/$runId'
      path: '/$runId'
      fullPath: '/runs/$runId'
      preLoaderRoute: typeof RunsRunIdRouteImport
      parentRoute: typeof RunsRoute
    }
    '/knowledge/$itemId': {
      id: '/knowledge/$itemId'
      path: '/$itemId'
      fullPath: '/knowledge/$itemId'
      preLoaderRoute: typeof KnowledgeItemIdRouteImport
      parentRoute: typeof KnowledgeRoute
    }
    '/integrations/$cadEnv': {
      id: '/integrations/$cadEnv'
      path: '/$cadEnv'
      fullPath: '/integrations/$cadEnv'
      preLoaderRoute: typeof IntegrationsCadEnvRouteImport
      parentRoute: typeof IntegrationsRoute
    }
    '/catalog/$macroId': {
      id: '/catalog/$macroId'
      path: '/$macroId'
      fullPath: '/catalog/$macroId'
      preLoaderRoute: typeof CatalogMacroIdRouteImport
      parentRoute: typeof CatalogRoute
    }
    '/workflows/compose/$workflowId': {
      id: '/workflows/compose/$workflowId'
      path: '/$workflowId'
      fullPath: '/workflows/compose/$workflowId'
      preLoaderRoute: typeof WorkflowsComposeWorkflowIdRouteImport
      parentRoute: typeof WorkflowsComposeRoute
    }
  }
}

interface CatalogRouteChildren {
  CatalogMacroIdRoute: typeof CatalogMacroIdRoute
  CatalogIndexRoute: typeof CatalogIndexRoute
}

const CatalogRouteChildren: CatalogRouteChildren = {
  CatalogMacroIdRoute: CatalogMacroIdRoute,
  CatalogIndexRoute: CatalogIndexRoute,
}

const CatalogRouteWithChildren =
  CatalogRoute._addFileChildren(CatalogRouteChildren)

interface IntegrationsRouteChildren {
  IntegrationsCadEnvRoute: typeof IntegrationsCadEnvRoute
  IntegrationsIndexRoute: typeof IntegrationsIndexRoute
}

const IntegrationsRouteChildren: IntegrationsRouteChildren = {
  IntegrationsCadEnvRoute: IntegrationsCadEnvRoute,
  IntegrationsIndexRoute: IntegrationsIndexRoute,
}

const IntegrationsRouteWithChildren = IntegrationsRoute._addFileChildren(
  IntegrationsRouteChildren,
)

interface KnowledgeRouteChildren {
  KnowledgeItemIdRoute: typeof KnowledgeItemIdRoute
  KnowledgeIndexRoute: typeof KnowledgeIndexRoute
}

const KnowledgeRouteChildren: KnowledgeRouteChildren = {
  KnowledgeItemIdRoute: KnowledgeItemIdRoute,
  KnowledgeIndexRoute: KnowledgeIndexRoute,
}

const KnowledgeRouteWithChildren = KnowledgeRoute._addFileChildren(
  KnowledgeRouteChildren,
)

interface RunsRouteChildren {
  RunsRunIdRoute: typeof RunsRunIdRoute
  RunsIndexRoute: typeof RunsIndexRoute
}

const RunsRouteChildren: RunsRouteChildren = {
  RunsRunIdRoute: RunsRunIdRoute,
  RunsIndexRoute: RunsIndexRoute,
}

const RunsRouteWithChildren = RunsRoute._addFileChildren(RunsRouteChildren)

interface WorkflowsComposeRouteChildren {
  WorkflowsComposeWorkflowIdRoute: typeof WorkflowsComposeWorkflowIdRoute
}

const WorkflowsComposeRouteChildren: WorkflowsComposeRouteChildren = {
  WorkflowsComposeWorkflowIdRoute: WorkflowsComposeWorkflowIdRoute,
}

const WorkflowsComposeRouteWithChildren =
  WorkflowsComposeRoute._addFileChildren(WorkflowsComposeRouteChildren)

interface WorkflowsRouteChildren {
  WorkflowsWorkflowIdRoute: typeof WorkflowsWorkflowIdRoute
  WorkflowsComposeRoute: typeof WorkflowsComposeRouteWithChildren
  WorkflowsIndexRoute: typeof WorkflowsIndexRoute
}

const WorkflowsRouteChildren: WorkflowsRouteChildren = {
  WorkflowsWorkflowIdRoute: WorkflowsWorkflowIdRoute,
  WorkflowsComposeRoute: WorkflowsComposeRouteWithChildren,
  WorkflowsIndexRoute: WorkflowsIndexRoute,
}

const WorkflowsRouteWithChildren = WorkflowsRoute._addFileChildren(
  WorkflowsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuditRoute: AuditRoute,
  BuilderRoute: BuilderRoute,
  CatalogRoute: CatalogRouteWithChildren,
  CopilotRoute: CopilotRoute,
  HostsRoute: HostsRoute,
  IntegrationsRoute: IntegrationsRouteWithChildren,
  KnowledgeRoute: KnowledgeRouteWithChildren,
  MyMacrosRoute: MyMacrosRoute,
  RunsRoute: RunsRouteWithChildren,
  SavedWorkflowsRoute: SavedWorkflowsRoute,
  SettingsRoute: SettingsRoute,
  TeamcenterRoute: TeamcenterRoute,
  WorkflowsRoute: WorkflowsRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
